<template>
  <div class="card_body intro-x">
    <div class="card_header">
      <div class="img-box">
        <div class="LeftPngIcon" v-if="CardData.icon">
          <img :src="CardData.icon" alt="" srcset="" />
        </div>

        <div class="LeftPng" :style="'background:' + CardData.color" v-else>
          <img src="@/assets/images/niao.png" alt="" />
        </div>
      </div>
      <div class="cardRihgt">
          <i class="el-icon-more" style="font-size: 20px; color: #bbc6da"></i>
      </div>
      <div class="cardRight2">
        <img :src="CardDataImg" alt="" />
        <span>{{ CardData.module_count }}个模块</span>
      </div>
    </div>
    <div class="CardData-name">{{ CardData.name }}</div>

    <div class="cardListText">
      <ul>
        <li>
          <span class="leftText">版本信息</span>
          <span class="rightText"> {{ CardData.platform | fSystem }}</span>
        </li>
        <li>
          <span class="leftText">APPID</span>
          <span class="rightText">{{ CardData.uuid }}</span>
        </li>
        <li>
          <span class="leftText">到期时间</span>
          <span class="rightText">{{ CardData.expire }}</span>
        </li>
      </ul>
    </div>
    <div class="cardButtom" @click.stop="getAppDetails">查看详情</div>
    <!--    <div class="cardButtom" @click.stop="getDetails">查看详情</div>-->
  </div>
</template>

<script>
export default {
  props: ["CardData"],
  data() {
    return {};
  },
  computed: {
    CardDataImg: function () {
      var url = null;
      if (this.CardData.platform === "ios") {
        url = require("../assets/images/ios.png");
      }
      if (this.CardData.platform === "android") {
        url = require("../assets/images/anzhuo.png");
      }
      if (this.CardData.platform === "web") {
        url = require("../assets/images/h5.png");
      }
      if (this.CardData.platform === "applet") {
        url = require("../assets/images/xiaochengxu.png");
      }
      return url;
    },
  },
  created() {},
  methods: {
    // 跳转至应用详情页
    getAppDetails: function () {
      const CardData = this.CardData;
      // console.log(CardData)
      this.$router.push({
        path: "Dashboard/AppDatails",
        query: CardData,
      });
    },
    // getDetails: function () {
    //   this.$message("装修进行中。");
    //   return;
    // },
  },
};
</script>

<style scoped>
/* pc */
@media screen and (max-width: 1172px) {
  .card_body {
    min-width: 47.2% !important;
  }
  .itemBoxB {
    width: 100% !important;
    margin-left: 0 !important;
    padding: 24px !important;
    display: block !important;
    float: none !important;
  }
}

@media screen and (max-width: 690px) {
  .card_body {
    width: 100% !important;
    display: block !important;
    float: none !important;
    padding-right: 54px !important;
    border-radius: 0 !important;
    min-width: 420px !important;
  }
}

.card_body {
  float: left;
  width: 31.2%;
  min-width: 306px;
  background: #fff;
  height: 328px;
  margin: 0 2% 20px 0;
  border-radius: 8%;
  box-sizing: border-box;
  padding: 24px;
}

.card_body:hover {
  box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.1);
}

/* .card_body:nth-child(3n + 5) {
  margin-right: 0;
} */

.card_header {
  width: 100%;
  font-size: 26px;
  color: #333333;
  overflow: hidden;
  margin-bottom: 5px;
}

.img-box {
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.LeftPngIcon {
  width: 75px;
  height: 75px;
  border-radius: 23px;
  overflow: hidden;
}

.LeftPngIcon > img {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

.LeftPng {
  width: 75px;
  height: 75px;
  line-height: 75px;
  text-align: center;
  border-right: 16px;
  overflow: hidden;
  border-radius: 23px;
}

.LeftPng > img {
  display: inline-block;
  width: 50px;
  vertical-align: -15px;
}

.cardRihgt {
  float: right;
  margin: 0 0 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border: 1px solid #BBC6DA;
  border-radius: 50%;
  opacity: 1;
}

.icon-box {
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border: 1px solid #bbc6da;
  box-sizing: border-box;
  border-radius: 50%;
}

.cardRight2 {
  width: 105px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #bbc6da;
  border-radius: 16px;
  float: right;
  color: #bbc6da;
  font-size: 12px;
  line-height: 32px;
  font-weight: 400;
  position: relative;
  text-indent: 40px;
}

.cardRight2 > img {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  position: absolute;
  left: -1px;
  top: -1px;
}

.cardListText,
ul,
li {
  overflow: hidden;
  width: 100%;
}

.cardListText li {
  line-height: 28px;
}

.leftText {
  float: left;
  color: #999999;
  font-size: 16px;
}
.rightText {
  float: right;
  color: #333333;
  font-size: 16px;
}

.cardButtom {
  background: #f7f7fa;
  width: 100%;
  height: 56px;
  box-sizing: border-box;
  border-radius: 22px;
  text-align: center;
  line-height: 56px;
  color: #8f9cc6;
  font-size: 16px;
  margin-top: 30px;
}

.cardButtom:hover {
  background: #1890fa;
  color: #fff;
  cursor: pointer;
}

.cardButtom:active {
  background: #58b0fd;
}

.CardData-name {
  width: 100%;
  overflow: hidden;
  color: #2d3748;
  font-size: 20px;
  line-height: 36px;
}

@media screen and (max-width: 600px) {
  .card_body {
    width: 93% !important;
    padding: 15px 15px 15px 15px !important;
    border-radius: 21px !important;
    min-width: auto !important;
  }
  .CardView-box2 {
    width: 100% !important;
  }
  .card_body {
    min-width: 0px !important;
  }
}
</style>